export default {
  "ORDER_WAIT_SHIP": "รอการส่งสินค้า",
  "Men fashion": "เสื้อผ้าชาย",
  "MyAccount_MyProfile_label_First": "ชื่อ",
  "MyAccount_MyShippingDetails_Phone": "หมายเลขโทรศัพท์",
  "Page_not_found_message1": "ขออภัยไม่พบหน้านี้",
  "Help": "ช่วยเหลือ",
  "Sign in": "เข้าสู่ระบบ",
  "Register": "สมัครสมาชิก",
  "Category_sorting_Item": "เลือกวิธีการเรียงลำดับ",
  "cart_clear": "ล้างตะกร้าสินค้า",
  "Payment & Delivery": "การชำระเงินและการจัดส่งสินค้า",
  "Send my feedback": "ส่งความคิดเห็นของฉัน",
  "MyAccount_MyProfile_Save": "บันทึกการเปลี่ยนแปลง",
  "Continue_billing": "ดำเนินการชำระเงินต่อ",
  "Categories": "หมวดหมู่",
  "Read and understand": "ฉันได้อ่านและเข้าใจแล้ว",
  "Feel free to edit": "แก้ไขข้อมูลของคุณใด ๆ เมื่อมีการเปลี่ยนแปลง เพื่อให้บัญชีของคุณเป็นปัจจุบันตลอดเวลา",
  "Select payment method": "เลือกวิธีการชำระเงิน",
  "Login_input_email": "อีเมลของคุณ",
  "Login_input_first": "ชื่อ",
  "Account": "บัญชีผู้ใช้",
  "Create_Time_Asc": "เวลาสร้างเอกสารน้อยไปมาก",
  "concactus_label": "ข้อเสนอแนะหรือข้อสงสัย",
  "Order_Grade": "การประเมินคะแนนออเดอร์",
  "wishlist_empty_desc": "ดูเหมือนคุณยังไม่ได้เพิ่มสินค้าใด ๆ เข้าตะกร้าสินค้าของคุณ และเริ่มการช้อปปิ้งเพื่อเติมช่องว่างในตะกร้าสินค้าของคุณ",
  "cartpreviewShipping_messageinfo": "คุณจะได้รับการยืนยันการส่งสินค้าและวันที่มาถึง",
  "unsubscribe": "คุณสามารถยกเลิกการรับข่าวสารได้ทุกเมื่อ",
  "prompt": "จำกัด",
  "MyAccount_MyProfile_yinsi_message": "ที่ Brand name เราให้ความสำคัญกับความเป็นส่วนตัวและอยู่รอดในการดูแลข้อมูลส่วนบุคคลของผู้ใช้ หากคุณต้องการเรียนรู้เพิ่มเติมเกี่ยวกับวิธีการดูแลและใช้ข้อมูลส่วนบุคคลของคุณโปรดดู",
  "About us": "เกี่ยวกับเรา",
  "or": "หรือ",
  "MyAccount_Order_History_All": "หมายเลขออเดอร์ทั้งหมด",
  "What_We_Improve": "เราจะปรับปรุงได้อย่างไร?",
  "MyAccount_ShippingDetails_title": "รายละเอียดการจัดส่งสินค้า",
  "MyAccount_Order_History_Tabs2": "รอการชำระเงิน",
  "Go_back_shopping": "กลับไปหน้าสินค้า",
  "Product": "สินค้า",
  "Order summary": "สรุปรายการสั่งซื้อ",
  "payment_order_total": "ยอดรวมการสั่งซื้อ",
  "Departments": "คณะกรรมการ",
  "Download": "ดาวน์โหลด",
  "Your_Purchase_Order": "รายการสั่งซื้อของคุณ",
  "Your_Account": "บัญชีผู้ใช้ของคุณ",
  "order_after_sales_list_null": "คุณยังไม่มีข้อมูลการซื้อขายหลังการขายใด ๆ",
  "All_After_sales_orders": "การสั่งซื้อหลังการขายทั้งหมด",
  "Filters": "ฟิลเตอร์",
  "search_results_not": "เราไม่พบผลลัพธ์ที่เกี่ยวข้องกับวลีที่ระบุ",
  "ORDER_WAIT_RECEIPT": "รอการรับสินค้า",
  "ORDER_CLOSED": "ปิด",
  "Order_View_details": "ดูรายละเอียด",
  "Subscribe_to_message": "ติดตามกิจกรรมการขายและโปรโมชั่นที่จะเปิดให้ใช้งานในไม่ช้า รับของขวัญและข้อเสนอพิเศษ!",
  "TaxFee": "ภาษีและค่าธรรมเนียม",
  "Apply": "สมัครใช้งาน",
  "Total_price": "ราคารวมทั้งหมด",
  "Description": "คำอธิบาย",
  "Payment method": "วิธีการชำระเงิน",
  "Back": "กลับ",
  "Empty": "ดูเหมือนว่าคุณยังไม่ได้เพิ่มสินค้าใดๆลงในตะกร้าสินค้าของคุณ โดยเริ่มต้นเลือกซื้อสินค้าเพื่อเติมช่องว่างในตะกร้าสินค้าของคุณ",
  "After_sales": "การซื้อขายหลังการขาย",
  "Instruction3": "ใช่ เรารู้",
  "MyAccount_MyShippingDetails_Last": "นามสกุล",
  "MyAccount_MyShippingDetails_City": "เมือง",
  "payment_order_discount": "ส่วนลดราคาสินค้า",
  "MyAccount_Order": "ข้อมูลรายการสั่งซื้อ",
  "ID_Name_Error": "กรุณาใส่ชื่อผู้ใช้บัญชีของคุณ",
  "Kidswear": "เสื้อผ้าเด็ก",
  "Share your look": "แชร์ลุคของคุณ",
  "Pay_Order": "ชำระเงินสั่งซื้อ",
  "Reset_Password": "รีเซ็ตรหัสผ่าน",
  "MyAccount_MyProfile_label2_pass1": "รหัสผ่านปัจจุบัน",
  "Create_Time_Desc": "เวลาสร้างเอกสารมากไปน้อย",
  "Items": "สินค้า",
  "Login_Register": "ลงทะเบียนทันที",
  "Back to homepage": "กลับสู่หน้าหลัก",
  "switch_CNY": "สลับเป็นภาษีเงินไทย",
  "Successful placed order": "คุณได้ทำการสั่งซื้อเรียบร้อยแล้ว คุณสามารถตรวจสอบสถานะการสั่งซื้อของคุณโดยใช้ฟังก์ชั่นสถานะการจัดส่งของเรา คุณจะได้รับอีเมลยืนยันการสั่งซื้อพร้อมรายละเอียดการจัดส่งสินค้าและลิงก์ติดตาม",
  "MyAccount_MyProfile_yinsi_link": "นโยบายความเป็นส่วนตัว",
  "Order_Date": "วันที่สั่งซื้อ",
  "Allow order notifications": "อนุญาตการแจ้งเตือนสำหรับออเดอร์",
  "MyAccount_MyProfile_Tab1": "ข้อมูลส่วนตัว",
  "MyAccount_ShippingDetails_changeTitle": "เปลี่ยนที่อยู่",
  "ID_Number": "หมายเลขบัตรประชาชน",
  "Order_after_sales_message": "รายละเอียดและการสั่งซื้อหลังการขาย",
  "MyAccount_MyProfile_title2": "หากคุณต้องการเปลี่ยนรหัสผ่านของบัญชีของคุณหรือเข้าถึงบัญชีของคุณโปรดป้อนข้อมูลดังต่อไปนี้",
  "Customer service": "บริการลูกค้า",
  "MyAccount_MyProfile_Update": "อัปเดตรหัสผ่าน",
  "choose_language": "เลือกภาษา",
  "ORDER_REFUNDING": "กำลังขอคืนเงิน",
  "MyAccount_MyProfile_title1": "แก้ไขรายละเอียดที่เกี่ยวข้องด้านล่างเมื่อมีการเปลี่ยนแปลง ในการอัปเดตข้อมูลบัญชีของคุณเพื่อให้สอดคล้องกับข้อมูลปัจจุบันตลอดเวลา",
  "ORDER_WAIT_RATE": "รอการประเมินคะแนน",
  "after_sales_refund_order": "การเรียกร้องเงินคืนสินค้า",
  "Who we are": "เราคือใคร",
  "Women fashion": "เสื้อผ้าหญิง",
  "Personal details": "ข้อมูลส่วนตัว",
  "Password": "รหัสผ่าน",
  "wishlist_empty_title": "ไม่มีสิ่งที่คุณต้องการ",
  "Repeat_Password": "ยืนยันรหัสผ่าน",
  "cart_price": "ราคารวม",
  "Sort_by": "เรียงตาม",
  "Customer Reviews": "รีวิวของลูกค้า",
  "Continue to shipping": "ดำเนินการจัดส่งสินค้าต่อ",
  "payment_make_order": "สั่งซื้อสินค้า",
  "save_order_review": "ส่งความคิดเห็น",
  "Save_Password": "บันทึกรหัสผ่าน",
  "cart_empty_title": "ไม่มีสินค้าในรถเข็นของคุณ",
  "TopBar_help": "ช่วยเหลือและคำตอบปัญหาที่พบบ่อย",
  "colseCookie": "ฉันรู้แล้ว",
  "Password_Changed": "เปลี่ยนรหัสผ่านเรียบร้อยแล้ว คุณสามารถกลับไปที่หน้าหลักและเข้าสู่ระบบได้เลย",
  "Forgot Password Modal Email": "อีเมลที่คุณใช้สำหรับการเข้าสู่ระบบของคุณ:",
  "MyAccount_Personal": "ข้อมูลส่วนตัว",
  "cartPreviewShipping": "การจัดส่งสะดวก",
  "ORDER_AFTER_SALE": "หลังการขาย",
  "Page_not_found": "ไม่พบหน้านี้",
  "Find out more": "เรียนรู้เพิ่มเติม",
  "Log into your account": "เข้าสู่บัญชีของคุณ",
  "Details_and_status_orders": "ตรวจสอบรายละเอียดและสถานะการสั่งซื้อของคุณในร้านค้าออนไลน์ คุณยังสามารถยกเลิกการสั่งซื้อหรือขอคืนสินค้าได้",
  "Order_to_be_paid_message": "รอการชำระเงิน",
  "Guarantee": "ความปลอดภัย",
  "Sections that interest you": "ส่วนที่น่าสนใจของคุณ",
  "payment_post_tax": "ภาษีเงินได้หลังจากส่งสินค้า",
  "ORDER_PAID": "ชำระเงินแล้ว",
  "concactus_label5": "นามธรรมชาติ",
  "Item": "สินค้า",
  "Go_back": "กลับไปที่หน้าก่อนหน้านี้",
  "more": "ข้อมูลเพิ่มเติม",
  "MyAccount": "บัญชีของฉัน",
  "payment_agree_1": "ฉันยอมรับ",
  "total_items": "จำนวนรวม",
  "shopping_go": "จัดการที่อยู่จัดส่งสินค้า",
  "ID_Type": "ประเภทบัตรประชาชน",
  "after_sales_status": "สถานะหลังการขาย",
  "After_sales_apply": "ยื่นขอหลังการขาย",
  "Login": "เข้าสู่ระบบ",
  "Quantity": "จำนวน",
  "payment_post_fee": "ค่าส่งสินค้า",
  "MyAccount_Log_out": "ออกจากระบบ",
  "Subtotal": "ราคาต่อหน่วย",
  "forgotPasswordConfirmation": "ขอบคุณ! หากได้ลงทะเบียนบัญชีชื่อ {0} ด้วยอีเมลอยู่แล้ว จะได้รับข้อความที่มีลิงค์การรีเซ็ตรหัสผ่านในกล่องจดหมายของคุณ",
  "MyAccount_Order_History_Tabs1": "ประวัติการสั่งซื้อของฉัน",
  "concactus_img": "อัปโหลดรูปภาพ",
  "Done": "เสร็จสิ้น",
  "Info after order": "คุณสามารถเข้าสู่ระบบบุคคลที่สามของคุณได้โดยใช้อีเมลและรหัสผ่านที่คุณกำหนดไว้ก่อนหน้านี้ ในบัญชีของคุณคุณสามารถแก้ไขข้อมูลประวัติส่วนตัว ดูประวัติการซื้อขาย และแก้ไขการสมัครรับข่าวสาร",
  "MyAccoubnt_Set_newsletter": "ตั้งค่าจดหมายข่าวของคุณ หลังจากเลือกส่วนที่คุณชอบแล้ว เราจะส่งข้อมูลผลิตภัณฑ์และแนวโน้มใหม่ๆ ให้กับคุณทุกสัปดาห์",
  "Shipping_method": "วิธีจัดส่งสินค้า",
  "after_sales_refund": "จำนวนเงินที่คืนจากการขายหลังการขาย",
  "After_sales_save": "บันทึกข้อมูลหลังการขาย",
  "go_order_history": "ดูประวัติการสั่งซื้อ",
  "contactus_message_placeholder": "โปรดแสดงความคิดเห็นหรือคำถามของคุณ",
  "Login_Forgot_Password": "หากคุณลืมรหัสผ่านของคุณ คุณสามารถตั้งค่ารหัสผ่านใหม่ได้",
  "show_more": "แสดงเพิ่มเติม",
  "MyAccount_MyProfile_label_email": "อีเมลของคุณ",
  "MyAccount_MyProfile_label2_pass3": "ยืนยันรหัสผ่าน",
  "Products": "สินค้า",
  "Review": "รีวิว",
  "MyAccount_MyProfile_title3": "ที่อยู่อีเมลปัจจุบันของคุณคือ",
  "Category_found_Products": "พบสินค้า",
  "Match": "เลือก",
  "Read_all_reviews": "อ่านรีวิวทั้งหมด",
  "Commercial information": "และตกลงรับข้อมูลการตลาดทันทีจาก Brand name ผ่านทางอีเมลที่กำหนดเอง",
  "Change password your account": "หากคุณต้องการเปลี่ยนรหัสผ่านการเข้าถึงบัญชีของคุณ กรุณาใส่ข้อมูลด้านล่างนี้",
  "ID_Name": "ชื่อบนบัตรประชาชน",
  "All": "ทั้งหมด",
  "Instruction2": "คุณต้องการคำแนะนำเพียงอย่างเดียวหรือไม่?",
  "MyAccount_ShippingDetails_Add": "เพิ่มที่อยู่ใหม่",
  "MyAccount_MyShippingDetails_Zip": "รหัสไปรษณีย์",
  "go_pay_order": "ไปที่การชำระเงิน",
  "Thank_You_Inbox": "หากคุณไม่ได้รับข้อความในกล่องจดหมายของคุณโปรดลองอีเมลอื่นที่คุณอาจใช้สำหรับการลงทะเบียน",
  "Subscribe": "สมัครรับข่าวสาร",
  "confirm_subscription": "ขอยืนยันการสมัครรับข่าวสาร",
  "Login_input_Remember": "จดจำฉัน",
  "Add to compare": "เพิ่มเพื่อเปรียบเทียบ",
  "Brand": "แบรนด์",
  "Start_shopping": "เริ่มชอปปิ้ง",
  "Select shipping method": "เลือกวิธีจัดส่งสินค้า",
  "address CN": "ที่อยู่ในประเทศจีน สกุลเงินปัจจุบันจะต้องเป็นบาท",
  "MyAccount_MyShippingDetails_State": "รัฐ / จังหวัด",
  "Page_not_found_message2": "โปรดย้อนกลับหรือลองใหม่",
  "Go_to_checkout": "ไปยังการเช็คเอาต์",
  "See all results": "ดูผลลัพธ์ทั้งหมด",
  "search_results_inputnull": "คุณยังไม่ได้ค้นหาสินค้าใด ๆ",
  "subscribeToNewsletterModalContent": "หลังจากสมัครรับข่าวสารคุณจะได้รับข้อเสนอและข้อมูลสิ่งที่เราสนใจของ VSF ผ่านทางอีเมล ตลอดช่วงเวลาที่เลือก สำหรับการขายหรือกระทบต่อตลาดอื่น ๆ ของเราจะไม่ทำการเปิดเผยหรือแจกจ่ายอีเมลของคุณให้กับบุคคลที่สาม",
  "Download all": "ดาวน์โหลดทั้งหมด",
  "Login_input_last": "นามสกุล",
  "Amount": "จำนวนเงิน",
  "ORDER_WAIT_PAYMENT": "รอการชำระเงิน",
  "Order_After_sales": "การจัดการหลังการขายสินค้า",
  "concattus_button": "ส่ง",
  "Shipping_valid_required": "ต้องระบุข้อมูลในช่องนี้",
  "Price": "ราคา",
  "ID_Type_Error": "โปรดเลือกประเภทบัตรประชาชนของคุณ",
  "Order_Status": "สถานะคำสั่งซื้อ",
  "Payment methods": "วิธีการชำระเงิน",
  "MyAccount_MyProfile_Tab2": "เปลี่ยนรหัสผ่าน",
  "Show on page": "แสดงในหน้าเว็บไซต์",
  "Edit": "แก้ไข",
  "Change": "เปลี่ยนแปลง",
  "MyAccount_ShippingDetails_Update": "อัปเดตที่อยู่",
  "View": "ดู",
  "Privacy": "ความเป็นส่วนตัว",
  "Enter_promo_code": "ใส่โค้ดส่วนลด",
  "Discount": "ส่วนลด",
  "Delete": "ลบ",
  "Wishlist": "รายการที่ต้องการ",
  "MyAccount_Order_History_Tabs3": "สินค้าที่คืนได้",
  "Go_To_Order_review": "ไปที่การประเมินสินค้า",
  "Update personal data": "อัปเดตข้อมูลส่วนตัว",
  "payment_agree_2": "ข้อกำหนดและเงื่อนไข",
  "or fill the details below": "หรือกรอกรายละเอียดด้านล่างนี้",
  "Contact details updated": "อัปเดตที่อยู่และรายละเอียดการติดต่อของคุณ",
  "Login_Create": "สร้างบัญชีผู้ใช้",
  "Payment": "ชำระเงิน",
  "Billing": "การเรียกเก็บเงิน",
  "payment_insurance_tax": "ภาษีประกันภัย",
  "Size guide": "คู่มือการเลือกไซส์",
  "Login_forgotten_password": "ลืมรหัสผ่าน",
  "Login_no_account": "ยังไม่มีบัญชีผู้ใช้",
  "Privacy_Policy": "นโยบายความเป็นส่วนตัว",
  "BootomCookieTitle": "การให้สัญญาณตกลงใช้บริการคุกกี้",
  "Use your personal data": "ที่ Brand name เราให้ความสำคัญกับการเก็บรักษาความเป็นส่วนตัวของผู้ใช้ของเราและมุ่งมั่นที่จะปกป้องข้อมูลส่วนบุคคลของคุณ หากต้องการดูข้อมูลเพิ่มเติมเกี่ยวกับวิธีการดูแลและใช้ข้อมูลส่วนบุคคลของคุณ โปรดดูที่",
  "Review my order": "ตรวจสอบคำสั่งซื้อของฉัน",
  "BootomCookieLink": "เรียนรู้เพิ่มเติม",
  "hide": "ซ่อน",
  "MyAccount_ShippingDetails_message_title": "จัดการที่อยู่จัดส่งทั้งหมดของคุณ (สำหรับที่ทำงานหรือที่อยู่บ้าน ฯลฯ) เพื่อไม่ต้องป้อนที่อยู่จัดส่งเองในทุกคำสั่งซื้อ",
  "Purchase terms": "เงื่อนไขการซื้อสินค้า",
  "Billing_address": "ที่อยู่สำหรับวางบิล",
  "Manage shipping addresses": "จัดการที่อยู่จัดส่งทั้งหมดของคุณ (สำหรับที่ทำงานหรือที่อยู่บ้าน ฯลฯ) เพื่อไม่ต้องป้อนที่อยู่จัดส่งเองในทุกคำสั่งซื้อ",
  "login_logbtn": "เข้าสู่ระบบ",
  "choose_currency": "เลือกสกุลเงิน",
  "ORDER_REFUNDED": "คืนเงินแล้ว",
  "After_sales_form": "กรอกแบบฟอร์มรับสินค้าที่ถูกขายหลังการมีการขาย",
  "add_To_Wishlist": "เพิ่มไปยังรายการที่ต้องการ",
  "search_results_inputnull2": "เริ่มต้นค้นหาเดี๋ยวนี้ เรามีพร้อมช่วยคุณ",
  "Total": "รวมทั้งหมด",
  "Subscribe_to_newsletter": "สมัครรับข่าวสาร",
  "Shipping_valid_Phone": "โปรดกรอกหมายเลขโทรศัพท์ที่ถูกต้อง",
  "concactus_label3": "หัวข้อ",
  "Manage billing addresses": "จัดการที่อยู่วางบิลทั้งหมดของคุณ (สำหรับที่ทำงานหรือที่อยู่บ้าน ฯลฯ) เพื่อไม่ต้องป้อนที่อยู่วางบิลเองในทุกคำสั่งซื้อ",
  "Search_results_title": "ผลการค้นหา",
  "payment_order_payment": "การชำระเงินสำหรับคำสั่งซื้อ",
  "after_sales_Id": "หมายเลขสินค้าที่คืนได้",
  "cart_title": "รถเข็นของฉัน",
  "Order_Detail": "รายละเอียดคำสั่งซื้อ",
  "concactus_label2": "ลิงก์ร้านค้า",
  "Shipping_valid_length_min": "ต้องมีอย่างน้อย {min} ตัวอักษรในช่องนี้",
  "Product suggestions": "คำแนะนำสินค้า",
  "Return_home": "กลับสู่หน้าหลัก",
  "Quality in the details": "คุณภาพรายละเอียด",
  "Continue_to_payment": "ดำเนินการชำระเงินต่อไป",
  "Feedback": "ความคิดเห็นของคุณมีค่าสำหรับเรา โปรดบอกเราว่าเราสามารถปรับปรุงอะไรได้บ้าง",
  "Go back to shop": "กลับไปยังร้านค้า",
  "Back_to_home": "กลับสู่หน้าหลัก",
  "Review_Content": "เนื้อหาการประเมินสินค้า",
  "add_To_Cart": "เพิ่มลงในตะกร้าสินค้า",
  "Read_reviews": "อ่านความคิดเห็น",
  "Instruction1": "วิธีการดูแลรักษา",
  "Email_address": "ที่อยู่อีเมล์",
  "Category_Item_List": "แสดงในรูปแบบรายการ",
  "Same as shipping address": "เหมือนกับที่อยู่จัดส่งสินค้า",
  "Category_Item_Grid": "แสดงในรูปแบบกริด",
  "ID_Number_Error": "โปรดระบุหมายเลขบัตรประชาชนของคุณ",
  "concactus_label4": "อีเมลการติดต่อ",
  "Additional_info": "ข้อมูลเพิ่มเติม",
  "add_shipping": "เพิ่มที่อยู่จัดส่งสินค้าใหม่",
  "Product_description": "Karissa V-Neck Tee ถูกออกแบบมาในสไตล์น้ำตาลสุกให้กับคนที่รักการออกกำลังกายทบทวนสุขภาพของตนเอง เสื้อยืดตัวงอที่ดีเหมาะสำหรับหลายๆรูปแบบของร่างกาย สามารถปกปิดพื้นที่ปัญหาพื้นๆที่พบบ่อยได้อย่างมั่นใจ สำหรับเสื้อผ้าเลิศสตรีลูกค้าของเราจะได้เห็นเป็นเอกลักษณ์ใน",
  "Login_create_account": "สร้างบัญชีแล้ว",
  "after_sales_Reason": "เหตุผลของการขายหลังการขายสินค้า",
  "MyAccount_MyProfile_label_Last": "นามสกุล",
  "MyAccount_MyProfile_label2_pass2": "รหัสผ่านใหม่",
  "Save": "บันทึก",
  "CartSliderTextBtn": "บันทึกไว้ซื้อในภายหลัง",
  "Color": "สี",
  "Shipping_Tax": "ภาษีการขนส่ง",
  "Subscribe_to_success": "คุณได้สมัครรับแล้ว",
  "Enjoy your free account": "รับประโยชน์จากบัญชีฟรีของคุณได้แล้ว !",
  "cart_empty_desc": "ดูเหมือนว่าคุณยังไม่มีสินค้าที่เพิ่มลงในรถเข็นของคุณ ลองเริ่มหาสินค้าที่ชอบตอนนี้เลย !",
  "MyAccount_ShippingDetails_message_title2": "อัปเดตที่อยู่และรายละเอียดการติดต่อของคุณ",
  "An_error_occured": "เกิดข้อผิดพลาด",
  "Country": "ประเทศ",
  "MyAccount_MyShippingDetails_First": "ชื่อ",
  "payment_insurance_fee": "ค่าธรรมเนียมการประกัน",
  "Home": "หน้าหลัก",
  "Contact_us": "ติดต่อเรา",
  "Cookies Policy": "นโยบายคุกกี้",
  "Clear all": "ล้างทั้งหมด",
  "Basket": "ตะกร้าสินค้า",
  "MyAccount_MyProfile_reqeatPassErrMsg": "รหัสผ่านใหม่ไม่ตรงกัน",
  "Your current email address is": "ที่อยู่อีเมลปัจจุบันของคุณคือ",
  "You currently have no orders": "ขณะนี้คุณไม่มีคำสั่งซื้อใด ๆ",
  "Login_input_password": "รหัสผ่าน",
  "Promo_code": "รหัสโปรโมชั่น",
  "order_count": "จำนวนคำสั่งซื้อ",
  "email_geshi_error": "โปรดป้อนที่อยู่อีเมลที่ถูกต้อง",
  "your_email": "อีเมลของคุณ",
  "email": "อีเมล",
  "you_have_subscribed": "คุณได้สมัครรับแล้ว",
  "cancel_Subscribe": "ยกเลิกการสมัครรับข่าวสาร",
  "save_and_pay": "บันทึกและชำระเงิน",
  "hasInsurance": "มีการซื้อประกันหรือไม่",
  "pleasePayType": "โปรดเลือกวิธีการชำระเงิน",
  "zhuanfa_toBePay": "แจ้งเพื่อนให้ชำระเงินแทนคุณ",
  "linkCopied": "คัดลอกลิ้งค์แล้ว ไปแชร์กับเพื่อนๆ ได้เลย",
  "Links": "ลิงค์",
  "article_category": "หมวดหมู่บทความ",
  "wechat_code_login_message": "กรุณาใช้ WeChat สแกนรหัสคิวอาร์โค้ดเพื่อเข้าสู่ระบบ",
  "wechat_code_login": "เข้าสู่ระบบด้วย WeChat ด้วยการสแกนรหัสคิวอาร์โค้ด",
  "Api_Update_success": "อัปเดตเรียบร้อยแล้ว",
  "Please_Use_WeChat_login": "กรุณาใช้ WeChat เพื่อเข้าสู่ระบบ",
  "mobile_geshi_error": "กรุณาป้อนหมายเลขโทรศัพท์ที่ถูกต้อง",
  "Login_input_email_required": "กรุณาใส่อีเมล",
  "article_null": "ไม่มีบทความ",
  "Login_with_microsoft": "เข้าสู่ระบบของ Microsoft",
  "article_null_des": "คุณสามารถเรียกดูบทความในหมวดอื่นได้",
  "register_email": "ลงทะเบียนด้วยอีเมล",
  "Login_tab_email": "เข้าสู่ระบบด้วยอีเมล",
  "code.time": "{time} วินาที ก่อนลองใหม่อีกครั้ง",
  "Login_with_wechat": "เข้าสู่ระบบด้วย WeChat",
  "cat_items_null_des": "คุณสามารถเรียกดูสินค้าแบบอื่นในหมวดได้",
  "Login_with_facebook": "เข้าสู่ระบบด้วย Facebook",
  "Login_input_code": "รหัสยืนยัน",
  "Login_input_mobile_required": "กรุณาใส่หมายเลขโทรศัพท์มือถือ",
  "Login_input_mobile": "หมายเลขโทรศัพท์มือถือของคุณ",
  "cat_items_null": "ไม่มีสินค้าในหมวดนี้",
  "Login_with_twitter": "เข้าสู่ระบบด้วย Twitter",
  "mobile_code": "รหัสยืนยัน",
  "register_mobile": "ลงทะเบียนด้วยโทรศัพท์มือถือ",
  "Login_tab_mobile": "เข้าสู่ระบบด้วยโทรศัพท์มือถือ",
  "Login_with_google": "เข้าสู่ระบบด้วย Google",
  "OrderSku": "สเปกสินค้า",
  "Order_logisticsNo": "หมายเลขพัสดุ",
  "order_shopping_firstname": "ชื่อ",
  "Order_logisticsName": "บริษัทขนส่ง",
  "ItemPrice": "ยอดเงินสินค้า",
  "inPayOrderAll": "รายการที่ต้องชำระเงิน",
  "payPrice": "ยอดชำระเงิน",
  "shipping_add_success": "สร้างที่อยู่จัดส่งสำเร็จ",
  "match_goods": "สินค้าขายดี",
  "pay_code_refresh": "รีเฟรชรหัสการชำระเงิน",
  "pay_code_shixiao": "รหัสการชำระเงินไม่ถูกต้อง",
  "concactus_title": "ติดต่อเรา",
  "Search_items": "ค้นหา",
  "WebAutoLang": "ภาษาที่แนะนำสำหรับเบราว์เซอร์ของคุณคือ: {lang} คุณต้องการเปลี่ยนเป็นภาษานี้หรือไม่?",
  "Services_Name": "ชื่อบริการ",
  "Services_Price": "ค่าบริการ",
  "SwichLang": "สลับภาษา",
  "Services_Description": "คำอธิบายบริการ",
  "goodinfo_null": "ไม่มีสินค้าชั่วคราว",
  "goodinfo_null_des": "คุณสามารถเรียกดูสินค้าในหมวดอื่นได้",
  "notYetUseCode": "ยังไม่ได้ใช้โค้ดส่วนลด",
  "guest_Login": "เข้าสู่ระบบเป็นแขก",
  "billing_and_shipping": "ที่อยู่สำหรับวางบิลและจัดส่งเหมือนกัน",
  "select_coupon": "เลือกคูปอง",
  "select_gift": "เลือกของขวัญ",
  "currentUseCode": "ใช้โค้ดส่วนลดแล้ว",
  "shipping_refresh": "รีเฟรชรายการ",
  "Shipping_details": "ที่อยู่จัดส่ง",
  "MyAccount_Newsletter": "การสมัครรับข่าวสาร",
  "MyAccount_Profile": "ข้อมูลส่วนตัว",
  "MyAccount_Wishlist": "รายการสิ่งที่ปรารถนา",
  "See_all": "ทั้งหมด",
  "MyAccount_History": "บันทึกการสั่งซื้อ",
  "bind_microsoft": "การผูกกับ Microsoft",
  "bind_twitter": "การผูกกับ Twitter",
  "bind_facebook": "การผูกกับ Facebook",
  "bind_wechat_code": "รหัสคิวอาร์โค้ดของ WeChat",
  "bind_wechat": "การผูกกับ WeChat",
  "bind_google": "การผูกกับ Google",
  "Wishlist_Empty": "ไม่มีรายการที่ต้องการ",
  "discount_post_fee": "ส่วนลดค่าจัดส่ง",
  "ORDER_PART_PAID": "ชำระบางส่วน",
  "claimCouponeSuccess": "รับ {name} สำเร็จ",
  "discount_kou": "{ส่วนลด} เปอร์เซ็นต์",
  "claimCoupone": "รับ",
  "cartPreviewSafety_messageinfo": "การจัดส่งที่ปลอดภัยและรวดเร็วถึงที่อยู่ของคุณ",
  "Order_No": "หมายเลขออร์เดอร์",
  "cartPreviewSafety": "การจัดส่งที่ปลอดภัย",
  "Shipping": "การจัดส่ง",
  "MyAccount_MyShippingDetails_Street": "ถนน",
  "MyAccount_MyShippingDetails_HouseNumber": "หมายเลขที่อยู่",
  "Shipping_title": "ที่อยู่จัดส่ง",
  "Offline_payment": "การชำระเงินแบบออฟไลน์",
  "shopName": "ชื่อร้านค้า",
  "Social": "สังคมสัมพันธ์",
  "SERVICE": "บริการ",
  "onlineContact": "ติดต่อออนไลน์",
  "confirm": "ยืนยัน",
  "closeOrder": "ยกเลิกการสั่งซื้อ",
  "closeOrderContext": "คุณต้องการยกเลิกการสั่งซื้อหรือไม่?",
  "Message_Read": "อ่านแล้ว",
  "close.order.success": "การยกเลิกการสั่งซื้อสำเร็จ",
  "shippingAddress": "ที่อยู่สำหรับการจัดส่ง",
  "Message": "ข้อความ",
  "Message_Empty_Title": "การแจ้งเตือนของคุณว่างเปล่า",
  "MyAccount_Message": "ข้อความ",
  "Message_Empty": "ไม่มีข้อความ",
  "payment_order_note": "หมายเหตุการสั่งซื้อ",
  "go_to_see_prepid": "คลิกที่นี่เพื่อดูคำสั่งซื้อที่ยังไม่ได้ชำระเงิน",
  "operate": "ดำเนินการ",
  "removeCartItemContext": "คุณแน่ใจหรือไม่ว่าต้องการเอา {title} ออก?",
  "shippingItemQty": "จำนวนการจัดส่ง",
  "removeCartItem": "ลบรายการสินค้า",
  "shippingInfo": "ข้อมูลการจัดส่ง",
  "Distributor_success": "ได้เป็นตัวแทนจำหน่ายเรียบร้อยแล้ว",
  "Distributor_apply": "สมัครเป็นตัวแทนจำหน่าย",
  "Distributor_Details": "ตัวแทนจำหน่าย",
  "DistributorSataus": "สถานะ",
  "Distributor_Details_Empty": "ไม่มีตัวแทนจำหน่าย",
  "distributor.status.4": "ยกเลิกแล้ว",
  "distributor.status.1": "ยังไม่ได้ตรวจสอบ",
  "Distributor_copy_url": "คัดลอกลิงค์การแบ่งปัน",
  "Order_Time": "เวลาที่สั่งซื้อ",
  "Order_User": "ผู้สั่งซื้อ",
  "Distributor_copy_success": "คัดลอกสำเร็จ",
  "distributor.status.3": "จ่ายเงินแล้ว",
  "MyAccount_Distributor": "ตัวแทนจำหน่าย",
  "MyAccoubnt_Set_Distributor": "สมัครเป็นตัวแทนจำหน่าย",
  "distributor.status.2": "รอการจ่ายเงิน",
  "DistributorAmount": "ค่าคอมมิชชั่น",
  "Distributor_shenheshibai": "ไม่ผ่านการตรวจสอบซื้อขาย",
  "Distributor_shenhezhong": "กำลังตรวจสอบซื้อขาย",
  "Distributor_Order_Empty": "ไม่มีคำสั่งจัดจำหน่าย",
  "NE": "นีเจอร์",
  "DJ": "จิบูตี",
  "KP": "เกาหลีเหนือ",
  "US": "สหรัฐอเมริกา",
  "LC": "เซนต์ลูเซีย",
  "NL": "เนเธอร์แลนด์",
  "CD": "คองโก-กินชาซา",
  "IS": "ไอซ์แลนด์",
  "MA": "โมร็อกโก",
  "GH": "กานา",
  "KR": "เกาหลีใต้",
  "MK": "มาซิโดเนีย",
  "HT": "เฮติ",
  "PF": "เฟรนช์โปลินีเซีย",
  "GA": "กาบอง",
  "TD": "ชาด",
  "LB": "เลบานอน",
  "CG": "คองโก",
  "KG": "คีร์กีซสถาน",
  "TA": "ทริสตัน-ดากูเนีย",
  "KW": "คูเวต",
  "TL": "ติมอร์ตะวันออก",
  "IN": "อินเดีย",
  "NO": "นอร์เวย์",
  "NG": "ไนจีเรีย",
  "AQ": "แอนตาร์กติกา",
  "LY": "ลิเบีย",
  "NI": "นิการากัว",
  "TT": "ตรินิแดดและโตเบโก",
  "HM": "เกาะเฮิร์ดและหมู่เกาะแมคโดนัลด์",
  "PY": "ปารากวัย",
  "BA": "บอสเนียและเฮอร์เซโกวีนา",
  "JP": "ญี่ปุ่น",
  "MD": "มอลโดวา",
  "MT": "มอลตา",
  "RE": "เรอูนียง",
  "UG": "ยูกันดา",
  "SB": "หมู่เกาะโซโลมอน",
  "SL": "เซียร์ราลีโอน",
  "CV": "เคปเวิร์ด",
  "SD": "ซูดาน",
  "FO": "หมู่เกาะแฟโร",
  "ZA": "แอฟริกาใต้",
  "TR": "ตุรกี",
  "FK": "หมู่เกาะฟอล์กแลนด์",
  "PA": "ปานามา",
  "GF": "เฟรนซ์เกียนา",
  "TJ": "ทาจิกิสถาน",
  "NC": "นิวแคลิโดเนีย",
  "PM": "แซงปีแยร์และมีเกอลง",
  "NU": "นิวเวีย",
  "AO": "แองโกลา",
  "VN": "เวียดนาม",
  "GN": "กินี",
  "MW": "มาลาวี",
  "BY": "เบลารุส",
  "IM": "เกาะแมน",
  "BI": "บุรุนดี",
  "BS": "บาฮามาส",
  "CK": "หมู่เกาะคุก",
  "MH": "หมู่เกาะมาร์แชลล์",
  "CR": "คอสตาริกา",
  "HK": "ฮ่องกงจีน",
  "AD": "อันดอร์ร่า",
  "BN": "บรูไน",
  "SN": "เซเนกัล",
  "AE": "สหรัฐอาหรับเอมิเรตส์",
  "GI": "ยิบรอลตาร์",
  "CA": "แคนาดา",
  "AX": "หมู่เกาะโอลันด์",
  "UY": "อุรุกวัย",
  "WF": "วาลลิสและฟูตูนา",
  "GM": "แกมเบีย",
  "SO": "โซมาเลีย",
  "RU": "รัสเซีย",
  "PL": "โปแลนด์",
  "FM": "ไมโครนีเซีย",
  "ET": "เอธิโอเปีย",
  "EE": "เอสโตเนีย",
  "SK": "สโลวะเกีย",
  "AS": "อเมริกันซามัว",
  "ZM": "แซมเบีย",
  "AL": "แอลเบเนีย",
  "AT": "ออสเตรีย",
  "VA": "วาติกัน",
  "TW": "ไต้หวัน",
  "BD": "บังกลาเทศ",
  "AR": "อาร์เจนตินา",
  "EH": "ซาฮาร่าตะวันตก",
  "MO": "มาเก๊า จีน เทศบาลพิเศษ",
  "MV": "มัลดีฟส์",
  "GU": "กวม",
  "AW": "อารูบา",
  "AI": "แองกวิลลา",
  "CL": "ชิลี",
  "IL": "อิสราเอล",
  "GD": "เกรเนดา",
  "WS": "ซามัว",
  "SE": "สวีเดน",
  "GP": "กวาเดอลูป",
  "YE": "เยเมน",
  "GT": "กัวเตมาล่า",
  "BG": "บัลแกเรีย",
  "SJ": "สฟาร์แนเดนและยันมาเตน",
  "CO": "โคลอมเบีย",
  "LS": "เลโซโท",
  "LV": "ลัตเวีย",
  "UM": "เกาะเล็กๆของสหรัฐอเมริกา",
  "MX": "เม็กซิโก",
  "DO": "สาธารณรัฐโดมินิกัน",
  "PE": "เปรู",
  "HN": "หญิงดอส",
  "TC": "หมู่เกาะเตอร์กส์และไกเรนดายอง",
  "VI": "หมู่เกาะเวอร์จิน, อเมริกัน",
  "FJ": "ฟีจี",
  "MP": "หมู่เกาะนอร์เทิร์นมาเรียนา",
  "AC": "เกาะแอสเซนชัน",
  "NA": "นามิเบีย",
  "SZ": "สวาซิแลนด์",
  "RW": "รวันดา",
  "BH": "บาห์เรน",
  "KN": "เซนต์คิตส์และเนวิส",
  "TN": "ตูนิเซีย",
  "AF": "อัฟกานิสถาน",
  "VG": "หมู่เกาะเวอร์จิน, บริติช",
  "KE": "เคนยา",
  "PK": "ปากีสถาน",
  "GL": "กรีนแลนด์",
  "SY": "ซีเรีย",
  "CU": "คิวบา",
  "RS": "เซอร์เบีย",
  "BF": "บูร์กินาฟาโซ",
  "BM": "เบอร์มิวดา",
  "BZ": "เบลีซ",
  "SV": "เอลซัลวาดอร์",
  "CN": "จีน",
  "MF": "เซนต์มาร์ติน",
  "NF": "เกาะนอร์ฟอล์ค",
  "MZ": "โมซัมบิก",
  "LU": "ลักเซมเบิร์ก",
  "TO": "ตองกา",
  "GR": "กรีซ",
  "SI": "สโลวีเนีย",
  "PW": "ปาเลา",
  "TZ": "แทนซาเนีย",
  "IR": "อิหร่าน",
  "GG": "เกิร์นซีย์",
  "SM": "ซานมารีโน",
  "TF": "เฟรนช์เซาเทิร์นเทร์ริทอรีส์",
  "PS": "ปาเลสไตน์",
  "SC": "เซเชลส์",
  "BT": "ภูฏาน",
  "JM": "จาเมกา",
  "BR": "บราซิล",
  "CH": "สวิตเซอร์แลนด์",
  "SH": "เซนต์เฮเลนา",
  "HU": "ฮังการี",
  "TM": "เติร์กเมนิสถาน",
  "LT": "ลิทัวเนีย",
  "MC": "โมนาโก",
  "LI": "ลิกเตนสไตน์",
  "LR": "ไลบีเรีย",
  "GE": "จอร์เจีย",
  "SA": "ซาอุดีอาระเบีย",
  "GB": "สหราชอาณาจักร",
  "VE": "เวเนซุเอลา",
  "MU": "มอริเชียส",
  "HR": "โครเอเชีย",
  "SR": "ซูรินาเม",
  "CM": "แคเมอรูน",
  "IQ": "อิรัก",
  "BO": "โบลิเวีย",
  "MN": "มองโกเลีย",
  "DZ": "แอลจีเรีย",
  "TK": "โตเกียว",
  "MG": "มาดากัสการ์",
  "YT": "มายอต์",
  "CC": "หมู่เกาะโคโคส (คีลิง)",
  "LA": "ลาว",
  "PT": "โปรตุเกส",
  "QA": "กาตาร์",
  "AN": "แอนติลล์เนเธอร์แลนด์",
  "PN": "พิตแคร์น",
  "ES": "สเปน",
  "VC": "เซนต์วินเซนต์และเกรนาดีนส์",
  "AU": "ออสเตรเลีย",
  "CX": "เกาะคริสต์มาส",
  "KM": "คอโมโรส",
  "MR": "มอริเตเนีย",
  "FR": "ฝรั่งเศส",
  "SG": "สิงคโปร์",
  "BV": "เกาะบูเวต",
  "PH": "ฟิลิปปินส์",
  "CY": "ไซปรัส",
  "TV": "ตูวาลู",
  "CF": "สาธารณรัฐแอฟริกากลาง",
  "EC": "เอกวาดอร์",
  "GW": "กินี-บิสเซา",
  "IE": "ไอร์แลนด์",
  "LK": "ศรีลังกา",
  "ER": "เอริเทรีย",
  "GQ": "อิเควทอเรียลกินี",
  "NP": "เนปาล",
  "BE": "เบลเยียม",
  "GY": "กายอานา",
  "DK": "เดนมาร์ก",
  "MQ": "มาร์ตินีก",
  "UZ": "อุซเบกิสถาน",
  "CI": "โกตดิวัวร์",
  "ID": "อินโดนีเซีย",
  "BJ": "เบนิน",
  "ST": "เซาตูเมและปรินซิปี",
  "KH": "กัมพูชา",
  "KZ": "คาซัคสถาน",
  "MS": "มอนต์เซอร์รัต",
  "TH": "ไทย",
  "FI": "ฟินแลนด์",
  "ML": "มาลี",
  "AM": "อาร์เมเนีย",
  "IT": "อิตาลี",
  "NR": "นาอูรู",
  "PG": "ปาปัวนิวกินี",
  "ZW": "ซิมบับเว",
  "JO": "จอร์แดน",
  "OM": "โอมาน",
  "ME": "มอนเตเนโกร",
  "JE": "เจอร์ซีย์",
  "NZ": "นิวซีแลนด์",
  "VU": "วานูอาตู",
  "DE": "เยอรมนี",
  "CZ": "สาธารณรัฐเช็ก",
  "DM": "โดมินิกา",
  "KY": "หมู่เกาะเคย์แมน",
  "BW": "บอตสวานา",
  "RO": "โรมาเนีย",
  "PR": "เปอร์โตริโก",
  "AZ": "อาเซอร์ไบจาน",
  "IO": "บริติชอินเดียนโอเชียนเทร์ริทอรี",
  "UA": "ยูเครน",
  "TG": "โตโก",
  "MY": "มาเลเซีย",
  "AG": "แอนติกาและบาร์บูดา",
  "EG": "อียิปต์",
  "GS": "เกาะซาห์ดและเกาะซานด์วิช",
  "MM": "พม่า",
  "BB": "บาร์เบโดส",
  "KI": "คิริบาส",
  "All_Country": "ทั้งหมด",
  "post_state_country": "ค่าส่ง: {country} {state} {postFee} ",
  "zhichiDeliveryCountry": "การจัดส่งไปยัง",
  "ShippingFee": "ค่าจัดส่ง",
  "reviewOutOf": "{rating} ดาว，รวมทั้งหมด 5 ดาว",
  "product.pifa.label": "ซื้อ {startnum} - {endnum} ชิ้น",
  "product.pifa.type.1": "ส่วนลด",
  "Write_a_review": "เขียนรีวิว",
  "BasedOnTotalReviews": "ขึ้นอยู่กับ {total} รีวิว",
  "product.wholesale": "ราคาขายส่ง",
  "reviewMostRecent": "รีวิวล่าสุด",
  "product.pifa.type.2": "ราคาต่อชิ้น",
  "product.num.danwei": "ชิ้น",
  "good.shoppingDateLabel": "เวลาจัดส่งสินค้า",
  "good.shippingPeriod": "จัดส่งสินค้าภายในจำนวนวันที่กำหนด",
  "emailError": "รูปแบบอีเมลไม่ถูกต้อง",
  "addressNote": "หมายเหตุที่อยู่",
  "Concactus": "ติดต่อ",
  "addressMessage": "โปรดตรวจสอบให้แน่ใจว่าที่อยู่ของคุณถูกต้องและถูกต้อง หลังจากชำระเงินคุณจะไม่สามารถเปลี่ยนแปลงที่อยู่ได้",
  "showOrderSummary": "สรุปคำสั่งซื้อ",
  "payment_method": "วิธีการชำระเงิน",
  "emailNotNullError": "อีเมลไม่สามารถว่างเปล่าได้",
  "orderCreateLoading": "กำลังสร้างคำสั่งซื้อ...",
  "emailNote": "ติดต่อ",
  "emailMessage": "โปรดตรวจสอบให้แน่ใจว่าที่อยู่อีเมลของคุณถูกต้องและถูกต้อง เราจะส่งอีเมลยืนยันคำสั่งซื้อถึงคุณ",
  "payment_method_message": "การซื้อขายทั้งหมดเป็นการเข้ารหัสและปลอดภัย",
  "go_buy_goods": "ซื้อสินค้าต่อ",
  "tap_cancel_order": "คลิกที่นี่เพื่อยกเลิกคำสั่งซื้อ",
  "order_review": "การประเมินสินค้า",
  "Add_new_address": "เพิ่มที่อยู่ใหม่",
  "promo_code_type_3": "รหัสคูปองแถมเต็มโปรแกรม",
  "IdCardNotNull": "กรุณากรอกข้อมูลชื่อจริงและนามสกุล",
  "UploadVideo": "อัปโหลดวิดีโอ",
  "video": "วิดีโอ",
  "UploadImage": "อัปโหลดรูปภาพ",
  "uploadImageing": "กำลังอัปโหลด...",
  "BillingInfoNotNull": "ข้อมูลใบเสร็จไม่สมบูรณ์",
  "promo_code_type_2": "คูปองเงินสด",
  "UploadError": "อัปโหลดไม่สำเร็จ",
  "promo_code_type_4": "รหัสคูปองลดค่าขนส่ง",
  "image": "รูปภาพ",
  "paymentMethodNotNull": "โปรดเลือกวิธีการชำระเงิน",
  "promo_code_type_1": "คูปองส่วนลด",
  "shippingInfoNotNull": "ข้อมูลการจัดส่งไม่สมบูรณ์",
  "reviewDetail": "รายละเอียดการประเมินความเห็น",
  "DeliveryCountry": "พื้นที่จัดส่ง",
  "prompt_error": "แจ้งเตือนความผิดพลาด",
  "save_review_success": "บันทึกความคิดเห็นสำเร็จ",
  "ORDER_COMPLETED": "เสร็จแล้ว",
  "crate_after_sales": "สร้างการขายหลังการขาย",
  "Thank_You_Order": "ขอบคุณสำหรับคำสั่งซื้อของคุณ!",
  "Thank_You_Order_sub": "ขอบคุณที่สั่งซื้อสินค้า แล้วเราจะเริ่มดำเนินการต่อไปในเร็วๆนี้ โปรดตรวจสอบอีเมลของคุณเพื่อดูข้อมูลเกี่ยวกับการดำเนินการของคำสั่งซื้อ",
  "BootomCookieContext": "เว็บไซต์นี้ใช้คุกกี้เพื่อช่วยให้เว็บไซต์ทำงานได้อย่างปกติและช่วยให้เราเข้าใจวิธีการโต้ตอบกับมัน เราใช้คุกกี้เหล่านี้เพื่อให้คุณได้รับประสบการณ์ผู้ใช้ที่เน้นการปรับแต่งมากขึ้น หากคุณยังคงใช้เว็บไซต์นี้ เราจะเห็นว่าคุณยินยอมใช้คุกกี้",
  "order_reivice_message": "คุณแน่ใจไหมว่าได้รับสินค้าแล้ว?",
  "order_reivice_btn": "ยืนยันการรับสินค้า",
  "order_reivice_label": "การจัดส่งสินค้า",
  "order_reivice_success": "ยืนยันการรับสินค้าสำเร็จ",
  "collpase_show": "ดูเพิ่มเติม",
  "collpase_hide": "ซ่อน",
  "CouponCode": "โค้ดส่วนลด",
  "wechatPayScannerCode": "โปรดใช้ WeChat สแกนโค้ดชำระเงิน",
  "processing": "处理中หลังการขาย",
  "finished": "หลังการขาย完成แล้ว",
  "login.showPrice": "เข้าสู่ระบบเพื่อดูราคา",
  "After_Sales_Unknown": "สถานะการขายหลังที่ไม่ทราบ",
  "order_payment_list_null": "ไม่มีคำสั่งซื้อที่รอชำระเงิน",
  "Cancel": "ยกเลิก",
  "thankyou_concat": "หากคุณมีคำถามใดๆ กรุณาติดต่อเรา"
}